import { takeLatest, call, put } from "redux-saga/effects";
import { AccountReviewAction } from "../actions";
import * as types from "../actions/actionTypes";
import queryString from "query-string";
import moment from "jalali-moment";
import { createBrowserHistory } from "history";
import * as accountReviewApi from "../api/accountReview";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
moment.locale("fa");

export function* watcherAccountReview() {
  yield takeLatest(types.API_CALL_ACCOUNT_REVIEW_REQUEST, worker);
  yield takeLatest(types.SELECTED_TAB_ACCOUNT_REVIEW, tabWorker);
}

async function fetchList(account_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  const history = createBrowserHistory();
  const filters = {
    file_type: "web",
    end_date: " ", // moment().local('fa').format('YYYY/MM/DD'),
    start_date: " ", // moment().subtract(1, 'months').local('fa').format('YYYY/MM/DD'),
    account_type: account_type,
    activity_detail_type: [1, 2, 3, 29],
    contact_list: [],
    user_list: [],
    destination_bank_account_list: [],
    destination_fund_list: [],
    destination_type: [],
    payment_detail_type: [],
    payment_type: [10, 11, 12],
    receive_detail_type: [],
    receive_type: [10, 11, 12],
    sort_field: "date",
    sort_type: "desc",
    source_bank_account_list: [],
    source_fund_list: [],
    source_type: [],
    text_search: "",
    use_detail: false
  };
  let urlFilters = await queryString.parse(document.location.search);

  let parsed = {
    ...urlFilters,
    start_date: urlFilters.start_date || filters.start_date,
    end_date: urlFilters.end_date || filters.end_date,
    date_type: urlFilters.date_type || 3
  };
  if (urlFilters.date_type !== undefined) {
    switch (parseInt(urlFilters.date_type)) {
      case 1:
        parsed.start_date = moment()
          .subtract(1, "months")
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      case 2:
        parsed.start_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      default:
        parsed.start_date = urlFilters.start_date;
        parsed.end_date = urlFilters.end_date;
    }
  }
  parsed.start_date = parsed.start_date.split("/").join("-");
  parsed.end_date = parsed.end_date.split("/").join("-");
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  if (history.location.search !== "" && oldSearch !== search) {
    history.push({ search: `?${search}` });
  }
  urlFilters = {
    ...urlFilters,
    start_date: parsed.start_date.split("-").join("/"),
    end_date: parsed.end_date.split("-").join("/"),
    contact_list:
      urlFilters.contact_list !== undefined
        ? [urlFilters.contact_list]
        : filters.contact_list,
    user_list:
      urlFilters.user_list !== undefined
        ? [urlFilters.user_list]
        : filters.user_list,
    source_type:
      urlFilters.source_type !== undefined
        ? urlFilters.source_type.split(",")
        : filters.source_type,
    source_fund_list:
      urlFilters.source_fund_list !== undefined
        ? urlFilters.source_fund_list.split(",")
        : filters.source_fund_list,
    source_bank_account_list:
      urlFilters.source_bank_account_list !== undefined
        ? urlFilters.source_bank_account_list.split(",")
        : filters.source_bank_account_list,
    destination_type:
      urlFilters.destination_type !== undefined
        ? urlFilters.destination_type.split(",")
        : filters.destination_type,
    destination_fund_list:
      urlFilters.destination_fund_list !== undefined
        ? urlFilters.destination_fund_list.split(",")
        : filters.destination_fund_list,
    destination_bank_account_list:
      urlFilters.destination_bank_account_list !== undefined
        ? urlFilters.destination_bank_account_list.split(",")
        : filters.destination_bank_account_list,
    activity_detail_type:
      urlFilters.activity_detail_type !== undefined &&
      urlFilters.activity_detail_type !== ""
        ? urlFilters.activity_detail_type.split("-")
        : filters.activity_detail_type,
    sort_field:
      urlFilters.sort_field !== undefined &&
      urlFilters.sort_field === "start_date"
        ? "date"
        : parsed.sort_field
        ? parsed.sort_field
        : filters.sort_field
  };
  if (urlFilters.contact_list !== undefined) {
    if (parseInt(urlFilters.contact_list) === 0) {
      urlFilters.contact_list = [];
    }
    if (
      isNaN(urlFilters.contact_list) &&
      urlFilters.contact_list &&
      urlFilters.contact_list.toString() === "_1"
    ) {
      urlFilters.contact_list = [-1];
    }
  }
  if (urlFilters.user_list !== undefined) {
    if (parseInt(urlFilters.user_list) === 0) {
      urlFilters.user_list = [];
    }
  }
  const finalFilter = { ...filters, ...urlFilters };
  return accountReviewApi.getList(page_number, finalFilter);
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    yield put(AccountReviewAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(AccountReviewAction.getFailure(error));
  }
}

function* tabWorker(action) {
  try {
    yield call(AccountReviewAction.selectTab, action.selectedTab);
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}
